// src/.../sidebar/PaymentStatusSection.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Chip, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const pagoLabel = (p) => (!p ? '—' : p === 'enLinea' ? 'En línea' : p === 'diaEvento' ? 'Efectivo' : p);

const statusMap = {
  Pagado:     { color: 'success', label: 'Pagado' },
  EnProgreso: { color: 'primary', label: 'En Progreso' },
  Pendiente:  { color: 'warning', label: 'Pendiente' },
  Rechazado:  { color: 'error',   label: 'Rechazado' },
};

function PaymentStatusSection({ value, readOnly = true, onChange }) {
  const status = value?.status || 'Pendiente';
  const chip = statusMap[status] || statusMap.Pendiente;
  const pago = value?.pago || value?.paymentMethod || '';

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Status & Pago</Typography>

      {readOnly ? (
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          <Box>
            <Typography variant="caption" color="text.secondary">Status</Typography>
            <Box sx={{ mt: .5 }}><Chip size="small" color={chip.color} label={chip.label} /></Box>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Tipo de Pago</Typography>
            <Typography sx={{ mt: .5 }}>{pagoLabel(pago)}</Typography>
          </Box>
        </Box>
      ) : (
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          <FormControl size="small" fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              label="Status"
              value={status}
              onChange={(e) => onChange((p) => ({ ...p, status: e.target.value }))}
            >
              {Object.keys(statusMap).map((s) => (
                <MenuItem key={s} value={s}>{statusMap[s].label}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small" fullWidth>
            <InputLabel>Tipo de Pago</InputLabel>
            <Select
              label="Tipo de Pago"
              value={pago || ''}
              onChange={(e) => onChange((p) => ({ ...p, pago: e.target.value }))}
            >
              <MenuItem value=""><em>—</em></MenuItem>
              <MenuItem value="enLinea">En línea</MenuItem>
              <MenuItem value="diaEvento">Efectivo</MenuItem>
            </Select>
          </FormControl>
        </Box>
      )}
    </Box>
  );
}

PaymentStatusSection.propTypes = {
  value: PropTypes.object,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default PaymentStatusSection;
